module.exports = __webpack_public_path__ + "img/m4.dc81d55abcbb32eb8de2cf471c7e3735.png";